// solutions（运营方案）页面私有文案：zh 为完整基准，en 逐 key 对齐
// 玩法 tab 的名称/步骤/优势来自 solution_tabs 表（后台可编辑），不在此字典
export interface SolutionsDict {
    meta: { title: string; description: string }
    hero: {
        badge: string
        titleA: string
        titleB: string
        subtitle: string
    }
    section2: {
        titleA: string
        titleB: string
        items: { title: string; desc: string }[]
    }
    cta: {
        title: string
        button: string
    }
}

export const solutionsDict: { zh: SolutionsDict; en: SolutionsDict } = {
    zh: {
        meta: {
            title: '运营方案 - YYGame',
            description: '丰富的运营玩法，带你玩转互动游戏：点单约玩、门票房、竞猜、联赛、跨房PK等多种运营方案组合，助力社交应用全链路增长。',
        },
        hero: {
            badge: 'Operation Solutions',
            titleA: '丰富的运营玩法，',
            titleB: '带你玩转互动游戏',
            subtitle: '多种运营玩法自由组合，助力全链路增长',
        },
        section2: {
            titleA: '不同玩法组合创新，',
            titleB: '助力社交应用全链路增长',
            items: [
                { title: '用户增长', desc: '玩法自带传播性，拉新裂变事半功倍' },
                { title: '用户活跃', desc: '高频互动场景，持续提升在线时长' },
                { title: '用户留存', desc: '赛事与长线运营，让用户来了就不想走' },
                { title: '应用营收', desc: '付费点单、门票、竞猜，多元变现组合' },
            ],
        },
        cta: {
            title: '获取游戏化方案，开启您的游戏化互动旅程',
            button: '联系商务',
        },
    },
    en: {
        meta: {
            title: 'Operation Solutions - YYGame',
            description: 'Rich operation innovations to power up your interactive games: Order & Play, Ticket Rooms, Predictions, Tournaments, Cross-Room PK and more — driving full-funnel growth for social apps.',
        },
        hero: {
            badge: 'Operation Solutions',
            titleA: 'Rich operation innovations,',
            titleB: 'power up your games',
            subtitle: 'Mix and match playstyles for full-funnel growth',
        },
        section2: {
            titleA: 'Mix, match and innovate —',
            titleB: 'full-funnel growth for social apps',
            items: [
                { title: 'Acquisition', desc: 'Viral playstyles that pull new users in' },
                { title: 'Engagement', desc: 'High-frequency interaction that extends session time' },
                { title: 'Retention', desc: 'Tournaments and long-term ops that keep users coming back' },
                { title: 'Revenue', desc: 'Paid orders, tickets and predictions in one monetization mix' },
            ],
        },
        cta: {
            title: 'Get your gamification plan and start the interactive journey',
            button: 'Contact Us',
        },
    },
}
